// @index(['./!(*.spec).ts', './*/index.ts'], f => `export * from '${f.path.replace(/\/index$/, '')}';`)
export * from './company-product-accessory.model';
export * from './company-product-type.model';
export * from './company-product.model';
export * from './customer-nego-price.model';
// @endindex